import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '@core/models';

@Component({
    selector: 'app-add-dialog-box',
    templateUrl: './add-dialog-box.component.html',
    styleUrls: ['./add-dialog-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AddDialogBoxComponent {

  //variables for dialog box data
  action: string;
  local_data: any;

  constructor(
    public dialogRef: MatDialogRef<AddDialogBoxComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData) {
      
    this.local_data = {...data};
    this.action = this.local_data.action;
  }

  doAction(){
    this.dialogRef.close({event: this.action, data: this.local_data});
  }

  closeDialog(){
    this.dialogRef.close({event: 'Cancel'});
  }

}


